import React from 'react';
import { ArticleType } from '../../types';
import { DocumentTextIcon, MusicalNoteIcon } from '@heroicons/react/24/outline';

type ArticleTypeBadgeSize = 'sm' | 'md' | 'lg';

interface ArticleTypeBadgeProps {
  type: ArticleType;
  size?: ArticleTypeBadgeSize;
  className?: string;
}

const sizeClasses: Record<ArticleTypeBadgeSize, { container: string; icon: string }> = {
  sm: { container: 'px-2 py-0.5 text-xs', icon: 'w-3 h-3' },
  md: { container: 'px-2.5 py-0.5 text-xs', icon: 'w-3 h-3' },
  lg: { container: 'px-2.5 py-0.5 text-sm', icon: 'w-5 h-5' }
};

const ArticleTypeBadge: React.FC<ArticleTypeBadgeProps> = ({
  type,
  size = 'sm',
  className = ''
}) => {
  const isAudio = type === 'audio';
  const styles = sizeClasses[size];

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${
      isAudio ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800'
    } ${styles.container} ${className}`}>
      {isAudio ? (
        <>
          <MusicalNoteIcon className={`${styles.icon} mr-1`} />
          Audio-Artikel
        </>
      ) : (
        <>
          <DocumentTextIcon className={`${styles.icon} mr-1`} />
          Text-Artikel
        </>
      )}
    </span>
  );
};

export default ArticleTypeBadge;
